import { Stack, Text, Button, Box, useMantineTheme } from '@mantine/core';
import { Actions, trackAction } from 'utils/amplitude';
import { Routes } from 'components/ui/PebbleNavbar';
import { PoweredByPebble } from '@icons';
import { useRouter } from 'next/router';
import classes from './BookContainer.module.scss';
import { ActivityTypeEnum } from 'enums';
import Link from 'next/link';
import { ListPlus } from '@phosphor-icons/react';

interface IBookingContainerProps {
  selectedSessionSpotsLeft?: number;
  waitlistLink: string;
  activityType: string;
}

const BookContainerEmbed: React.FC<IBookingContainerProps> = ({
  selectedSessionSpotsLeft,
  waitlistLink,
  activityType,
}) => {
  const theme = useMantineTheme();
  const router = useRouter();

  return (
    <Box className={classes.bookContainer}>
      {selectedSessionSpotsLeft === 0 ? (
        <Stack align="center">
          <Button
            onClick={() => trackAction(Actions.REQUEST_WAITLIST)}
            component="a"
            href={waitlistLink}
            className={classes.enquireButton}
            radius="xl"
            size="md"
            mt="md"
            fullWidth
            leftSection={<ListPlus size={24} />}
            rel="noopener noreferrer"
          >
            Join Waitlist
          </Button>
          {router.pathname.includes(Routes.SESSION_SELECT_ROUTE) && (
            <Stack align="center" mt={theme.spacing.sm}>
              <Link href="https://bookpebble.co.uk/solutions/activity-suppliers" target="_blank">
                <PoweredByPebble />
              </Link>
            </Stack>
          )}
        </Stack>
      ) : (
        <>
          {router.pathname.includes(Routes.SESSION_SELECT_ROUTE) && (
            <Stack align="center" mt={theme.spacing.sm}>
              <Link href="https://bookpebble.co.uk/solutions/activity-suppliers" target="_blank">
                <PoweredByPebble />
              </Link>
            </Stack>
          )}
        </>
      )}

      {activityType === ActivityTypeEnum.SUBSCRIPTION && (
        <Stack
          mt="md"
          mb={8}
          className={classes.cancelWrapper}
          gap={0}
          align="center"
          justify="center"
        >
          <Text className={classes.cancelCopy}>Subject to provider T&Cs</Text>
        </Stack>
      )}
    </Box>
  );
};

export default BookContainerEmbed;
